import { render, staticRenderFns } from "./MyShare.vue?vue&type=template&id=4ea1c2ba&scoped=true&"
import script from "./MyShare.vue?vue&type=script&lang=js&"
export * from "./MyShare.vue?vue&type=script&lang=js&"
import style0 from "./MyShare.vue?vue&type=style&index=0&id=4ea1c2ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea1c2ba",
  null
  
)

export default component.exports